import React from 'react';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import Label from 'components/form/Label/Label';
import { CSTooltip } from 'components/Tooltip/CSToolTip';
import { OVERVIEW } from 'types/mrph.pageName.constants';
import { SUGGESTED_AUTO_LOAN_OFFERS } from 'types/morph.pagePosition.constants';
import ResponsiveLabel from 'components/form/ResponsiveLabel';
import { Button } from 'components/form/Button';
import { getImageBasePath } from 'helpers/env';
import { formatNumberNoDecimals } from 'helpers/number';
import { AUTO_LOAN_VERTICAL } from 'types/marketplaceTiles.constants';

const AutoLoanRefinanceSavingsOffer = props => {
  return (
    <FlexContainer
      datatestid="autoloan-refinance-module"
      className="justify-between m-justify-center"
    >
      <div data-testid={`autoloan-refinance-offers`}>
        <FlexContainer className="align-baseline flex-column">
          <div className="padTB8 m-padB0">
            <ResponsiveLabel mobiletype="H5" desktoptype="H3">
              You could save up to
            </ResponsiveLabel>
          </div>
          <div className="padTB8 m-padB0 FlexContainer align-baseline">
            <div className="m-text-28 text-36 bold padR8">
              ${formatNumberNoDecimals(props.savingsAmount)}/mo.
            </div>
            <CSTooltip
              removeMarginsMobile
              isInline={true}
              placement={'bottom'}
              pageName={OVERVIEW}
              pagePosition={SUGGESTED_AUTO_LOAN_OFFERS}
              tooltipContent={props.autoLoanSectionTooltip}
              datatestid={`autoloan-refinance-tooltip`}
              tooltipName="How is this calculated"
              vertical={AUTO_LOAN_VERTICAL}
            >
              <Label type="link" className="Body-2 caption-large">
                How is this calculated?
              </Label>
            </CSTooltip>
          </div>
          <div className="padT8 padB16">
            <ResponsiveLabel mobiletype="Subtitle-1" desktoptype="H5">
              on your {props.autoLoanName} auto loan
            </ResponsiveLabel>
          </div>
          <div>
            Current monthly payment:{' '}
            <span className="bold">${props.monthlyPayment}</span>
          </div>
          <div className="text-center desktopHide padTB16">
            <img
              alt="save money on your auto loan"
              src={getImageBasePath() + 'images/art-autorefinance.svg'}
            />
          </div>
          <div className="padT36 format100 m-text-center text-left">
            <Button
              className="desktopHide margB12"
              mrphType="link"
              onClick={() =>
                props.goToRefinanceMarketplace(props.currentLoanDetails)
              }
            >
              See More Options
            </Button>
            <Button
              mrphType="primary"
              className="format40 margR8 m-margr0"
              onClick={props.clickDetailsHandler}
            >
              View Offer
            </Button>
            <span className="mobileHide">
              <Button
                mrphType="link"
                onClick={() =>
                  props.goToRefinanceMarketplace(props.currentLoanDetails)
                }
              >
                See More Options
              </Button>
            </span>
          </div>
        </FlexContainer>
      </div>
      <div className="mobileHide padT48">
        <img
          alt="save money on your auto loan"
          src={getImageBasePath() + 'images/art-autorefinance.svg'}
        />
      </div>
    </FlexContainer>
  );
};

export default AutoLoanRefinanceSavingsOffer;
